<template>
  <div class="w-100">
    <ul class="nav nav-tabs mb-3">
      <li class="nav-item">
        <button class="nav-link" :class="{ active: activeTab === 'budget' }" @click="activeTab = 'budget'">
          <i class="fa-solid fa-sack-dollar me-1" /> Budget
        </button>
      </li>
      <li class="nav-item">
        <button class="nav-link" :class="{ active: activeTab === 'status' }" @click="activeTab = 'status'">
          <i class="fa-solid fa-chart-pie me-1" /> Status
        </button>
      </li>
    </ul>

    <loading-spinner v-if="isLoading" />

    <template v-else>
      <budget-viz-tab
        v-if="activeTab === 'budget'"
        :selected-year="selectedYear"
        :hq="hq"
        :lines="lines"
        :budgets="budgets"
        :expenses="expenses"
        :cases="cases"
        :districts="districts"
      />
      <status-viz-tab
        v-if="activeTab === 'status'"
        :selected-year="selectedYear"
        :cases="cases"
        :districts="districts"
      />
    </template>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner";
import BudgetVizTab from "@/views/dashboard/BudgetVizTab";
import StatusVizTab from "@/views/dashboard/StatusVizTab";

export default {
  name: "dashboard-tabs",
  props: ["selectedYear"],
  components: { LoadingSpinner, BudgetVizTab, StatusVizTab },
  data() {
    return {
      activeTab: "budget",
      isLoading: false,
      hq: null,
      lines: [],
      budgets: [],
      expenses: [],
      cases: [],
      districts: [],
    };
  },
  watch: {
    selectedYear: { handler() { this.loadAll(); }, immediate: false },
  },
  methods: {
    async loadAll() {
      this.isLoading = true;
      const year = this.selectedYear || this.Helper.currentYear;
      await Promise.all([this.loadHq(year), this.loadBudgets(year), this.loadCases(), this.loadDistricts()]);
      this.isLoading = false;
    },
    async loadHq(year) {
      const [hqCall] = await this.Helper.handlePromise(this.API.get(`nod-budget-hqs?year=${year}`));
      this.hq = hqCall && hqCall.data && hqCall.data.length ? hqCall.data[0] : null;
      if (this.hq) {
        const [lineCall] = await this.Helper.handlePromise(
          this.API.get(`nod-budget-lines?hq=${this.hq.id}&_limit=-1`)
        );
        this.lines = lineCall && lineCall.data ? lineCall.data : [];
        const [expCall] = await this.Helper.handlePromise(
          this.API.get(`nod-budget-expenses?hq=${this.hq.id}&_limit=-1`)
        );
        this.expenses = expCall && expCall.data ? expCall.data : [];
      } else {
        this.lines = [];
        this.expenses = [];
      }
    },
    async loadBudgets(year) {
      const [call] = await this.Helper.handlePromise(this.API.get(`nod-budgets?year=${year}`));
      this.budgets = call && call.data ? call.data : [];
    },
    async loadCases() {
      // Keep ALL cases (incl. rejected): the Status tab counts a "Rejected" bucket,
      // and caseActual already excludes rejected internally for the Budget tab.
      const url = this.API.endpoints(this.selectedYear).allCases;
      const [call] = await this.Helper.handlePromise(this.API.get(url));
      this.cases = call && call.data ? call.data : [];
    },
    async loadDistricts() {
      const [call] = await this.Helper.handlePromise(this.API.get(this.API.endpoints().allDistricts));
      this.districts = call && call.data ? call.data : [];
    },
  },
  async mounted() {
    await this.loadAll();
  },
};
</script>
